import React, { createContext, useContext, useState, useEffect } from 'react';
import { assessmentsAPI } from '../services/api';

const ParticipantContext = createContext();

export const useParticipantCount = () => {
  const context = useContext(ParticipantContext);
  if (!context) {
    return { count: '250+', formatted: '250+' };
  }
  return context;
};

export const ParticipantProvider = ({ children }) => {
  const [count, setCount] = useState(250);
  const [formatted, setFormatted] = useState('250+');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const data = await assessmentsAPI.getBenchmark();
        if (data && data.total_assessments) {
          setCount(data.total_assessments);
          setFormatted(`${data.total_assessments}+`);
        }
      } catch (error) {
        console.error('Failed to fetch participant count:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCount();
  }, []);

  return (
    <ParticipantContext.Provider value={{ count, formatted, loading }}>
      {children}
    </ParticipantContext.Provider>
  );
};

export default ParticipantContext;
